/**
 * Created by alex.y on 9/5/2017.
 */
export enum CalculatorType{
    CanadianImport,
    UsaImport
}


// WEBPACK FOOTER //
// ./app/objects/orders/calculatorType.ts